import { LocalizationService } from '@abp/ng.core';
import { Component, inject, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-metro-notification',
  templateUrl: './metro-notification.component.html',
  standalone:false
})
export class MetroNotificationComponent implements OnInit {

@Input() title = '';
  @Input() message = '';
  @Input() type: 'info' | 'success' | 'warning' | 'error' = 'info';
  @Input() duration = 3000;
  @Input() params: string[] = [];


  visible = true;
  localizedMsg = '';
  localizedTitle = '';

  private readonly l = inject(LocalizationService);



  ngOnInit() {
  this.localizedMsg = this.l.instant(this.message, ...this.params);
  this.localizedTitle = this.l.instant(this.title);
  setTimeout(() => (this.visible = false), this.duration);
}
}
